/**
 * Realiza una solicitud HTTP utilizando Axios.
 *
 * @param {string} method - El método HTTP a utilizar (GET, POST, PUT, DELETE).
 * @param {string} url - La URL de la solicitud.
 * @param {object} source - El objeto que contiene el token de cancelación.
 * @param {array} [body] - El cuerpo de la solicitud (opcional).
 * @returns {Promise<any>} La respuesta de la solicitud.
 */

import axios from "axios";

export default async function AxiosFetch(method, url, source, body, header) {
  let token = localStorage.getItem("token");
  try {
    const config = {
      headers: {
        Pragma: "no-cache",
        "Cache-Control": "no-store",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": window.location.origin,
      },
    };
    let activeTimeoutSetting = localStorage.getItem("timeoutActive") === "true";

    if (activeTimeoutSetting) {
      let timoutSetting = localStorage.getItem("timeoutSetting");
      if (timoutSetting === null) {
        timoutSetting = 10000;
        localStorage.setItem("timeoutSetting", 10000);
      }
      config.timeout = timoutSetting;
    }

    if (source) {
      config.cancelToken = source.token;
    }
    if (method === "POST") {
      if (header) {
        config.headers["Content-Type"] =
          "multipart/form-data; boundary=<calculated when request is sent></calculated>";
      } else {
        config.headers["Content-Type"] = "application/json";
      }
    }

    let response;
    switch (method) {
      case "GET":
        response = await axios.get(url, config);
        break;
      case "POST":
        response = await axios.post(url, body, config);
        break;
      case "PUT":
        response = await axios.put(url, body, config);
        break;
      case "DELETE":
        response = await axios.delete(url, config);
        break;
      default:
        throw new Error(`Método no soportado: ${method}`);
    }

    // Espera a que se resuelva la promesa y emite la respuesta
    return await response.data;
  } catch (err) {
    if (axios.isCancel(err)) {
      const viewSocketLogs = localStorage.getItem("viewSocketLogs") !== "false";
      if (viewSocketLogs) {
        console.log(`successfully aborted ${url}`);
      }
    } else {
      // handle error
    }
  }
}

AxiosFetch.defaultProps = {
  method: "GET",
  url: "",
  source: null,
  body: null,
};
